/**
 * Location Form Page
 */

import { MapPin } from 'lucide-react'
import { CatalogFormPage } from './CatalogFormPage'
import { useTranslation } from '@/hooks/useTranslation'

export function LocationFormPage() {
  const { t } = useTranslation()

  return (
    <CatalogFormPage
      config={{
        endpoint: 'ubications',
        basePath: '/locations',
        title: t('catalogs.locations'),
        newTitle: t('catalogs.newLocation'),
        editTitle: t('catalogs.editLocation'),
        icon: MapPin,
        fields: [
          { key: 'code', label: t('articles.code'), type: 'text' },
          { key: 'name', label: t('clients.name'), type: 'text', required: true },
          { key: 'description', label: t('articles.description'), type: 'textarea' },
        ],
      }}
    />
  )
}
